import { jsx as _jsx } from "react/jsx-runtime";
import { Intercom } from '@intercom/messenger-js-sdk';
// components
import { Tabs } from "../../atoms";
import { ConversationList } from "../../organisms";
// models
import { ChatType } from '@karehero/models';
const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || '';
const CareExpertChat = ({ chatToken, chats, accountID, onCreateChat, }) => {
    if (chatToken) {
        Intercom({
            app_id: INTERCOM_APP_ID,
            region: 'eu',
            user_id: chatToken.userID,
            name: chatToken.name,
            email: chatToken.email,
            user_hash: chatToken.token,
            created_at: chatToken.createdAt,
        });
    }
    return (_jsx(ConversationList, { accountID: accountID, chats: (chats === null || chats === void 0 ? void 0 : chats.filter((chat) => chat.chatType === ChatType.ChatTypeHuman)) || [], onCreateChat: () => onCreateChat(ChatType.ChatTypeHuman) }));
};
/**
 * Messenger shows all chats.
 */
export const Messenger = (props) => {
    const { accountID, isKareheroAI, chats, onCreateChat } = props;
    return !isKareheroAI ? (_jsx(CareExpertChat, Object.assign({}, props))) : (_jsx(Tabs, { isNoPadding: true, tabs: [
            {
                id: 'jane-ai',
                label: 'Jane AI',
                isScroll: true,
                content: (_jsx(ConversationList, { accountID: accountID, chats: (chats === null || chats === void 0 ? void 0 : chats.filter((chat) => chat.chatType === ChatType.ChatTypeAgent)) || [], onCreateChat: () => onCreateChat(ChatType.ChatTypeAgent) })),
            },
            {
                id: 'care-expert',
                label: 'Care expert',
                content: _jsx(CareExpertChat, Object.assign({}, props)),
            },
        ] }));
};
Messenger.displayName = 'Messenger';
export default Messenger;
